import styled from '@emotion/styled'

export const StyleBg = styled.div`
  background: ${(props: any) => props.theme.colors.secondary150};
  padding: 0px 20px;
  height: 85dvh;
  border-radius: 12px;
  overflow: hidden;
`
